import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import InfosBlockPreview from "@project/components/InfosBlock/InfosBlockPreview";
export const InfosBlock = {
    label: "Bloc infos",
    type: ContentsCustomTypes.INFOS_BLOCK,
    Preview: InfosBlockPreview,
    icon: "list-ul",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Liste",
            key: "items",
            type: ContentsTypes.TEXT,
            value: "",
        },
    ],
};
